import { render, staticRenderFns } from "./ComixReader.vue?vue&type=template&id=169488c5&scoped=true&"
import script from "./ComixReader.vue?vue&type=script&lang=js&"
export * from "./ComixReader.vue?vue&type=script&lang=js&"
import style0 from "./ComixReader.vue?vue&type=style&index=0&id=169488c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169488c5",
  null
  
)

export default component.exports